import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SelectSearch, { fuzzySearch } from "react-select-search"

const AllIcons = ({ loadSVG }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "svg" } }) {
        edges {
          node {
            publicURL
            name
          }
        }
      }
    }
  `)

  const options = data.allFile.edges.map((file, index) => {
    return {
      name: file.node.name,
      value: file.node.publicURL,
      photo: file.node.publicURL,
    }
  })

  const renderIcon = (props, option, snapshot, className) => {
    return (
      <button
        {...props}
        className="w-full font-title font-bold p-1  text-left hover:bg-gray-300 bg-gray-100 border-b border-gray-600"
        type="button"
      >
        <span className="p">
          <img
            alt={option.name}
            className="inline  object-cover w-8 h-8 rounded-full bg-white p-1"
            src={option.photo}
          />
          <span className="p-2 uppercase truncate text-1xl">{option.name}</span>
        </span>
      </button>
    )
  }

  return (
    <SelectSearch
      onChange={loadSVG}
      className="select-search p-2 bg-gray-700 uppercase"
      options={options}
      search
      renderOption={renderIcon}
      name="Icons"
      placeholder="Choose an icon among +4000"
      filterOptions={options => {
        const filter = fuzzySearch(options)

        return q => filter(q).slice(0, 32)
      }}
    />
  )
}

export default AllIcons
